import React from "react";
import { FlexColumn } from "@/ui/FlexContainer/FlexContainer";
import { Skeleton } from "@/ui/Skeleton/Skeleton";
import cls from "./styles.module.scss";

// заглушка статистики: повторяет геометрию блоков,
// чтобы после загрузки ничего не прыгало

export const StatisticsSkeleton = () => (
  <FlexColumn gap={20}>
    {/* карточка периода с переключателем режима счёта */}
    <Skeleton height={112} radius={14} />

    {/* фильтр по тарифу */}
    <Skeleton height={58} radius={14} />

    {/* «Принесли эти рефералы» */}
    <div className={cls.hero}>
      <Skeleton height={14} width={100} />
      <Skeleton height={44} width={100} radius={10} style={{ marginTop: 12 }} />
      <Skeleton height={10} radius={100} style={{ marginTop: 18 }} />

      <FlexColumn gap={11} style={{ marginTop: 14 }}>
        <Skeleton height={14} width={70} />
        <Skeleton height={14} width={85} />
      </FlexColumn>
    </div>

    {/* «Кто дошёл до целей» */}
    <div className={cls.block}>
      <Skeleton height={15} width={100} />

      <FlexColumn gap={18} style={{ marginTop: 18 }}>
        {[55, 45, 50].map((width) => (
          <div key={width}>
            <Skeleton height={14} width={width} />
            <Skeleton height={8} radius={100} style={{ marginTop: 10 }} />
          </div>
        ))}
      </FlexColumn>
    </div>

    {/* «Заработано за всё время» */}
    <Skeleton height={54} radius={16} />

    {/* «Регистрации по дням» */}
    <div className={cls.block}>
      <Skeleton height={15} width={100} />
      <Skeleton height={120} radius={12} style={{ marginTop: 16 }} />
    </div>
  </FlexColumn>
);
